import { Editor, Node, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';

const withLinks = editor => {
	// Gather data from selection
	editor.prepareLink = () => {
		// Find current link element
		const [element] = Editor.nodes(editor, {
			match: node => node.type === 'link',
		}) ?? [];

		// Find fragment from current selection
		const [fragment] = Node.fragment(editor, editor?.selection) ?? [];

		// Get text from fragment
		const text = editor.isElementActive('link') && editor.isCollapsed()
			? Node.string(element?.[0])
			: Node.string(fragment);
		
		// Data preparation
		return {
			text: text,
			href: element?.[0]?.href ?? '',
			path: editor?.selection,
			editing: editor.isElementActive('link')
		};
	};

	// Insert link in selection
	editor.insertLink = (data) => {
		// Focus editor before inserting
		ReactEditor.focus(editor);

		// Select old path, because selection
		// was lost on link modal inputs
		Transforms.select(editor, data.path);

		// Check if link is active
		const isActive = editor.isElementActive('link');

		// Create link element
		const link = {
			type: 'link',
			href: data.href,
			children: [{
				text: data.text
			}]
		};

		// Remove link node
		if (isActive) Transforms.removeNodes(editor, {
			match: node => node.type === 'link'
		});

		// Inserts link in selection
		Transforms.insertNodes(editor, link);

		// Collapse selection
		Transforms.collapse(editor, { edge: 'end' });
	};

	// Removes link from selection
	editor.removeLink = (data) => {
		// Unwrap link format
		Transforms.unwrapNodes(editor, {
			match: node => node.type === 'link',
			at: data.path
		});

		// Refocus on editor
		ReactEditor.focus(editor);
	};

	return editor;
};

export default withLinks;